export default __webpack_public_path__ + "images/0f7467f4dfd9c3ed3efbe3be4c7b0e36-pride_small.webp";